import { render, staticRenderFns } from "./Zhongjiangliebiao.vue?vue&type=template&id=5d27269e&scoped=true&"
import script from "./Zhongjiangliebiao.vue?vue&type=script&lang=js&"
export * from "./Zhongjiangliebiao.vue?vue&type=script&lang=js&"
import style0 from "./Zhongjiangliebiao.vue?vue&type=style&index=0&id=5d27269e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d27269e",
  null
  
)

export default component.exports